module.exports = __webpack_public_path__ + "img/mine_actived.6ec0e230.png";